const weightMapping = {
    Regular: 400,
    Medium: 500,
    Semibold: 600,
};
const fonts = {
    DisplayLarge: {
        size: '1.75rem',
        weight: {
            Default: weightMapping.Semibold,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.29,
            'zh-hant': 1.42,
            'zh-cn': 1.42,
            vi: 1.29,
            th: 1.29,
        },
    },
    DisplaySmall: {
        size: '1.25rem',
        weight: {
            Default: weightMapping.Semibold,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.4,
            'zh-hant': 1.5,
            'zh-cn': 1.5,
            vi: 1.4,
            th: 1.4,
        },
    },
    Heading: {
        size: '1.125rem',
        weight: {
            Default: weightMapping.Semibold,
            Semibold: weightMapping.Semibold,
            Medium: weightMapping.Medium,
        },
        lineHeight: {
            en: 1.33,
            'zh-hant': 1.44,
            'zh-cn': 1.44,
            vi: 1.33,
            th: 1.33,
        },
    },
    Subheading: {
        size: '1rem',
        weight: {
            Default: weightMapping.Regular,
            Regular: weightMapping.Regular,
            Medium: weightMapping.Medium,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.5,
            'zh-hant': 1.5,
            'zh-cn': 1.5,
            vi: 1.5,
            th: 1.5,
        },
    },
    Menu: {
        size: {
            en: '0.875rem',
            'zh-hant': '1rem',
            'zh-cn': '1rem',
            vi: '0.875rem',
            th: '0.875rem',
        },
        weight: {
            Default: weightMapping.Regular,
        },
        lineHeight: {
            en: 1.5,
            'zh-hant': 1.5,
            'zh-cn': 1.5,
            vi: 1.5,
            th: 1.5,
        },
    },
    Body: {
        size: '0.875rem',
        weight: {
            Default: weightMapping.Regular,
            Regular: weightMapping.Regular,
            Medium: weightMapping.Medium,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.43,
            'zh-hant': 1.57,
            'zh-cn': 1.57,
            vi: 1.43,
            th: 1.43,
        },
    },
    Caption: {
        size: '0.8125rem',
        weight: {
            Default: weightMapping.Regular,
            Regular: weightMapping.Regular,
            Medium: weightMapping.Medium,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.23,
            'zh-hant': 1.54,
            'zh-cn': 1.54,
            vi: 1.23,
            th: 1.23,
        },
    },
    Micro: {
        size: '0.75rem',
        weight: {
            Default: weightMapping.Regular,
            Regular: weightMapping.Regular,
            Medium: weightMapping.Medium,
            Semibold: weightMapping.Semibold,
        },
        lineHeight: {
            en: 1.33,
            'zh-hant': 1.5,
            'zh-cn': 1.5,
            vi: 1.33,
            th: 1.33,
        },
    },
};
export default fonts;
//# sourceMappingURL=fonts.js.map